import React from 'react';
import PageContainer from 'common/components/PageContainer';
import DataTableWidget from "../../../../common/components/DataTableWidget";
import styles from "../../../InspectedList/components/InspectedListPage/styles.module.scss";

const columns = [
  {
    Header: 'מספר משימה',
    accessor: 'taskID',
  },
  {
    Header: ['מספר דוח', 'סוג נכס'],
    accessor: 'firmShumaIDAndPropertyType',
  },
  {
    Header: ['סוג משימה', 'סטטוס'],
    accessor: 'taskTypeAndTaskStatus',
  },
  {
    Header: 'לקוחות',
    accessor: 'customers',
  },
  {
    Header: 'כתובת',
    accessor: 'fullAddress',
  },
  {
    Header: 'תאריך לביצוע',
    accessor: 'dueDate',
  },
  {
    Header: '',
    accessor: 'tasksActions',
  },
];

const TasksPage = ({
                     list,
                     getTasks,
                     page,
                     setPage,
                     totalPages,
                     totalResultCount
                   }) => {

  return (
    <PageContainer>
      <DataTableWidget
        title={'המשימות שלי'}
        module={'TasksList'}
        getListHandler={getTasks}
        data={list}
        columns={columns}
        page={page}
        setPage={setPage}
        totalPages={totalPages}
        totalResults={totalResultCount}
        customClassNames={{
          headerCell: styles.customHeaderCell,
          row: styles.customRow
        }}
      />
    </PageContainer>
  );
};

export default TasksPage;